import { TCoreButtonOptions } from '../types/options';

const px = (value: unknown): string | undefined => (typeof value === 'number' ? `${value}px` : undefined);

export const buildButtonCssVars = (palette: TCoreButtonOptions): Record<string, string> => {
    const margin = palette.margin ?? {};
    const padding = palette.padding ?? {};

    const vars: Record<string, string | undefined> = {
        // Size
        '--cw-btn-width': px(palette.width),
        '--cw-btn-max-width': palette.maxWidth,
        '--cw-btn-height': px(palette.height),
        '--cw-btn-max-height': palette.maxHeight,
        // Border & Radius
        '--cw-btn-radius': px(palette.borderRadius),
        '--cw-btn-border-width': px(palette.borderStroke),
        // Typography
        '--cw-btn-font-family': palette.font,
        '--cw-btn-font-weight': typeof palette.fontStyle?.fontWeight === 'number' ? palette.fontStyle.fontWeight.toString() : undefined,
        '--cw-btn-font-size': px(palette.fontStyle?.fontSize),
        '--cw-btn-line-height': px(palette.fontStyle?.lineHeight),
        '--cw-btn-letter-spacing': px(palette.fontStyle?.letterSpacing),
        '--cw-btn-text-align': palette.textAlign,
        '--cw-btn-max-lines': typeof palette.maxLines === 'number' ? String(palette.maxLines) : undefined,
        // Elevation (box-shadow level)
        '--cw-btn-elevation': typeof palette.elevation === 'number' ? String(palette.elevation) : undefined,
        '--cw-btn-box-shadow': palette.boxShadow,
        // Icon
        '--cw-btn-icon-size': px(palette.iconSize),
        '--cw-btn-gap': px(palette.gap),
        // margin
        '--cw-btn-margin-top': px(margin.top),
        '--cw-btn-margin-right': px(margin.right),
        '--cw-btn-margin-bottom': px(margin.bottom),
        '--cw-btn-margin-left': px(margin.left),
        // padding
        '--cw-btn-padding-top': px(padding.top),
        '--cw-btn-padding-right': px(padding.right),
        '--cw-btn-padding-bottom': px(padding.bottom),
        '--cw-btn-padding-left': px(padding.left),
        // default
        '--cw-btn-color': palette.onMain,
        '--cw-btn-bg': palette.main,
        '--cw-btn-border-color': palette.outline,
        // hover
        '--cw-btn-color-hover': palette.hovered?.onMain,
        '--cw-btn-bg-hover': palette.hovered?.main,
        '--cw-btn-border-color-hover': palette.hovered?.outline,
        // active / pressed
        '--cw-btn-color-active': palette.pressed?.onMain,
        '--cw-btn-bg-active': palette.pressed?.main,
        '--cw-btn-border-color-active': palette.pressed?.outline,
        // disabled
        '--cw-btn-color-disabled': palette.disabled?.onMain,
        '--cw-btn-bg-disabled': palette.disabled?.main,
        '--cw-btn-border-color-disabled': palette.disabled?.outline,
        '--cw-btn-cursor-disabled': palette.cursorDisabled,
        // transition
        '--cw-btn-width-transition': palette.widthTransition,
    };

    return Object.fromEntries(Object.entries(vars).filter((entry): entry is [string, string] => entry[1] !== undefined));
};
